import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'sbnb-callout-card',
  templateUrl: './callout-card.component.html',
  styleUrls: ['./callout-card.component.scss'],
})
export class CalloutCardComponent implements OnInit {
  @Input() url: string;
  @Input() route: string | string[];
  @Input() target: string = '_self';
  @Input() title: string;
  @Input() icon: string;
  @Input() large: boolean;
  @Input() green: boolean;
  @Input() orange: boolean;
  @Input() grape: boolean;
  @Input() aqua: boolean;
  @Input() disabled: boolean;

  constructor() { }

  ngOnInit(): void { }
}
